/* Vinyasa Automotive — global.js
   Minimal vanilla JS: mobile drawer, mega-menu rail, predictive search, filter drawer,
   sticky add-to-cart, cart quick-add. No dependencies. Honors prefers-reduced-motion. */
(function () {
  "use strict";

  /* ---------- generic drawer open/close ---------- */
  function bindDrawer(openSel, drawerId) {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;
    var opener = null;
    function open() {
      opener = document.activeElement;
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      var f = drawer.querySelector("a,button,input,summary");
      if (f) f.focus();
    }
    function close() {
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (opener && typeof opener.focus === "function") opener.focus();
      opener = null;
    }
    document.querySelectorAll(openSel).forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
    drawer.querySelectorAll("[data-drawer-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    drawer.addEventListener("click", function (e) {
      if (e.target.classList.contains("drawer__scrim")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") close();
    });
  }
  bindDrawer("[data-drawer-open]", "MobileDrawer");
  bindDrawer("[data-filter-open]", "FilterDrawer");

  /* ---------- mega-menu department rail (hover/focus swaps panels) ---------- */
  document.querySelectorAll(".mega").forEach(function (mega) {
    var railLinks = mega.querySelectorAll(".mega__rail a[data-panel]");
    function activate(id) {
      mega.querySelectorAll(".mega__rail a[data-panel]").forEach(function (a) {
        a.classList.toggle("is-active", a.dataset.panel === id);
      });
      mega.querySelectorAll(".mega__panel").forEach(function (p) {
        p.classList.toggle("is-active", p.dataset.panelId === id);
      });
    }
    railLinks.forEach(function (a) {
      a.addEventListener("mouseenter", function () { activate(a.dataset.panel); });
      a.addEventListener("focus", function () { activate(a.dataset.panel); });
    });
  });
  /* Disclosure semantics: keep aria-expanded truthful, close on Escape / focus-out (UIUX-9) */
  document.querySelectorAll(".nav__item--has-mega > .nav__link").forEach(function (link) {
    var item = link.parentElement;
    var mega = item.querySelector(".mega");
    if (!mega) return;
    function setOpen(open) {
      mega.classList.toggle("is-open", open);
      link.setAttribute("aria-expanded", open ? "true" : "false");
    }
    link.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setOpen(!mega.classList.contains("is-open"));
      }
    });
    item.addEventListener("mouseenter", function () { link.setAttribute("aria-expanded", "true"); });
    item.addEventListener("mouseleave", function () { link.setAttribute("aria-expanded", "false"); });
    item.addEventListener("focusout", function (e) {
      if (!item.contains(e.relatedTarget)) setOpen(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mega.classList.contains("is-open")) { setOpen(false); link.focus(); }
    });
  });

  /* ---------- predictive search ----------
     ONE implementation (ARCH-T2): the server-rendered predictive-search section
     (escaped + localized Liquid) fetched via the Section Rendering API. Responses
     are sequence-guarded so a slow earlier reply can't overwrite a newer one
     (LOGIC-T4). */
  document.querySelectorAll("[data-predictive]").forEach(function (form) {
    var input = form.querySelector('input[type="search"], input[name="q"]');
    var box = form.querySelector(".predictive");
    if (!input || !box) return;
    var t = null, lastQ = "", seq = 0;
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { box.classList.remove("is-open"); return; }
      if (q === lastQ && box.innerHTML !== "") { box.classList.add("is-open"); return; }
      var mySeq = ++seq;
      var url = "/search/suggest?q=" + encodeURIComponent(q) +
        "&resources[type]=product,query&resources[limit]=6&section_id=predictive-search";
      fetch(url)
        .then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.text(); })
        .then(function (html) {
          if (mySeq !== seq) return; /* stale response — a newer query is in flight */
          var doc = new DOMParser().parseFromString(html, "text/html");
          var section = doc.querySelector(".shopify-section") || doc.body;
          box.innerHTML = section.innerHTML;
          box.classList.add("is-open");
          lastQ = q;
        })
        .catch(function () { if (mySeq === seq) { box.classList.remove("is-open"); lastQ = ""; } });
    }
    input.addEventListener("input", function () {
      clearTimeout(t); t = setTimeout(search, 200);
    });
    input.addEventListener("focus", function () { if (input.value.trim().length >= 2 && box.innerHTML !== "") box.classList.add("is-open"); });
    document.addEventListener("click", function (e) {
      if (!form.contains(e.target)) box.classList.remove("is-open");
    });
    input.addEventListener("keydown", function (e) { if (e.key === "Escape") box.classList.remove("is-open"); });
  });

  /* ---------- quantity stepper ---------- */
  document.querySelectorAll(".qty").forEach(function (q) {
    var input = q.querySelector("input");
    q.querySelectorAll("button[data-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1;
        v += b.dataset.step === "up" ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
  });

  /* ---------- panel swap (login <-> recover; ARCH-T6: no inline onclick) ---------- */
  document.querySelectorAll("[data-show-panel]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      var show = document.getElementById(a.getAttribute("data-show-panel"));
      var hide = document.getElementById(a.getAttribute("data-hide-panel"));
      if (hide) hide.classList.add("is-hidden");
      if (show) { show.classList.remove("is-hidden"); var f = show.querySelector("input"); if (f) f.focus(); }
    });
  });

  /* ---------- gallery thumbs ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    g.querySelectorAll("[data-gallery-thumb]").forEach(function (th) {
      th.addEventListener("click", function () {
        if (main) { main.src = th.dataset.full; main.srcset = ""; }
        g.querySelectorAll("[data-gallery-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        th.classList.add("is-active");
      });
    });
  });

  /* ---------- sticky mobile add-to-cart ---------- */
  var sticky = document.getElementById("StickyAtc");
  var atcAnchor = document.getElementById("ProductBuybox");
  if (sticky && atcAnchor && "IntersectionObserver" in window) {
    document.body.classList.add("has-sticky-atc");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle("is-visible", !en.isIntersecting); });
    }, { rootMargin: "-120px 0px 0px 0px" });
    io.observe(atcAnchor);
  }

  /* ---------- cart quick-add (AJAX) ----------
     Honest feedback: state is applied to EVERY submitter of the form — including
     the sticky-bar button associated via form= (MOBILE-4) — buttons are truly
     disabled while in flight (LOGIC-T3), and a non-2xx response shows the API's
     error instead of "Added" (LOGIC-T1). */
  function bumpCart() {
    document.querySelectorAll(".cart-count").forEach(function (c) {
      c.classList.remove("is-bump"); void c.offsetWidth; c.classList.add("is-bump");
    });
  }
  function refreshCartCount() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll(".cart-count").forEach(function (c) {
        c.textContent = cart.item_count; c.hidden = cart.item_count === 0;
      });
      bumpCart();
    });
  }
  function submittersOf(form) {
    var btns = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    if (form.id) {
      btns = btns.concat(Array.prototype.slice.call(
        document.querySelectorAll('[type="submit"][form="' + form.id + '"]')));
    }
    return btns;
  }
  function showFormError(form, msg) {
    var el = form.querySelector(".form-error");
    if (!el) {
      el = document.createElement("p");
      el.className = "form-error";
      el.setAttribute("role", "alert");
      form.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
  }
  function clearFormError(form) {
    var el = form.querySelector(".form-error");
    if (el) el.hidden = true;
  }
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches("form[data-ajax-cart]")) return;
    e.preventDefault();
    var btns = submittersOf(form);
    if (btns.some(function (b) { return b.disabled; })) return; /* already in flight */
    btns.forEach(function (b) {
      b.dataset.label = b.textContent;
      b.textContent = "Adding…";
      b.disabled = true;
      b.setAttribute("aria-disabled", "true");
    });
    function setAll(text) { btns.forEach(function (b) { b.textContent = text; }); }
    function unlock() {
      btns.forEach(function (b) {
        b.textContent = b.dataset.label;
        delete b.dataset.label;
        b.disabled = false;
        b.removeAttribute("aria-disabled");
      });
    }
    fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) {
            throw new Error(data.description || data.message || "Couldn't add to cart. Please try again.");
          }
          return data;
        });
      })
      .then(function () {
        clearFormError(form);
        refreshCartCount();
        setAll("Added ✓");
        setTimeout(unlock, 1400);
      })
      .catch(function (err) {
        setAll("Couldn't add");
        showFormError(form, (err && err.message) || "Couldn't add to cart. Please try again.");
        setTimeout(unlock, 2500);
      });
  });

  /* ---------- Partner apply forms (dealer / supplier programs) ----------
     A form[data-apply] posts its fields as JSON to its data-endpoint (the ape
     CORS apply API) via fetch, then shows an inline success/error message —
     no full-page redirect off the store. Progressive enhancement: without JS
     the form still points at data-endpoint via its action attribute. */
  document.querySelectorAll("form[data-apply]").forEach(function (form) {
    var endpoint = form.getAttribute("data-endpoint");
    var statusEl = form.querySelector("[data-apply-status]");
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!endpoint) return;

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = "apply-status " + (kind === "ok" ? "form-success" : "form-error");
      statusEl.hidden = false;
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (statusEl) statusEl.hidden = true;

      var payload = {};
      new FormData(form).forEach(function (v, k) { payload[k] = typeof v === "string" ? v.trim() : v; });

      var label = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Sending…"; }

      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (res.ok && res.data && res.data.ok) {
            form.reset();
            setStatus(res.data.message || "Thanks — your application has been received.", "ok");
          } else {
            setStatus((res.data && res.data.message) ||
              "Sorry, we couldn't submit your application. Please try again or email us.", "err");
          }
        })
        .catch(function () {
          setStatus("Network error — please check your connection and try again.", "err");
        })
        .then(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = label; }
        });
    });
  });
})();
